import * as moment from "moment";
import { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker-cssmodules.css"; // Use this CSS module
import "react-datepicker/dist/react-datepicker.css";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import clockIcon from "../../assets/images/clock.png";
import icroundsearch from "../../assets/images/ic_round-search.svg";
import playoutMonitoring from "../../assets/svg/Header/PlayoutMointer.svg";
import DashboardMonitoring from "../../assets/svg/Header/DashboardMonitor.svg";
import playstationLogo from "../../assets/svg/Playstudio_logo.svg";
import {
  adminModeAction,
  appThemeAction,
  MonitorDateAction,
  SearchChannelAction,
} from "../../Redux/slices";
import LogoutDropdown from "../Common/LogoutDropdown";
import ErrorPopup from "../popup/ErrorPopup";
import Tooltip from "../Tooltip";
import "./DashboardHeader.scss";

export default function DashboardHeader() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = window.location.href;

  const isMonitor = url.includes("monitor") || url.includes("gridMonitor");

  const admin = localStorage.getItem("adminMode");

  const location = useLocation();
  const [userActive, setUserActive] = useState(false);
  const [searchChannel, setSearchChannel] = useState(false);
  const timer = useRef(null);
  const [storeFrontAccess, setStoreFrontAccess] = useState("");
  const [userInfo, setUserInfo] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [errorbox, setErrorbox] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [eventTrim, seteventTrim] = useState(null);
  const {
    appThemeReducer: { appTheme },
    adminModeReducer: { adminMode },
  } = useSelector((state) => state);
  const newdate = new Date();
  const [formattedDateString, seFormattedDateString] = useState(
    moment(newdate).format("Do MMMM YYYY")
  );

  const monitorDate = () => {
    const newdate = new Date();
    seFormattedDateString(moment(newdate).format("dddd, Do MMMM’YY"));
  };

  useEffect(() => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      dispatch(SearchChannelAction(searchChannel));
    }, 300);
  }, [searchChannel]);

  useEffect(() => {
    dispatch(MonitorDateAction(startDate));
  }, [startDate]);

  const accessStore = async () => {
    const tenantLocalData = localStorage.getItem("tenantInfo");
    const tenantLocalDataParse = await JSON.parse(tenantLocalData);
    setStoreFrontAccess(tenantLocalDataParse?.superTenant);
  };
  const getUserDetail = async () => {
    const userLocalData = localStorage.getItem("userdetail");
    const userLocalDataParse = await JSON.parse(userLocalData);
    setUserInfo(userLocalDataParse);
  };
  useEffect(() => {
    accessStore();
    getUserDetail();
    dispatch(adminModeAction(admin === "true" ? true : false));
  }, []);

  const [currentDate, setCurrentDate] = useState(new Date());

  useEffect(() => {
    const timerID = setInterval(() => {
      setCurrentDate(new Date());
    }, 1000); // Update the date every second

    // Clean up the interval when the component unmounts
    return () => clearInterval(timerID);
  }, []);

  const formatDate = (date) => {
    const options = {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  };

  const formattedDate = formatDate(currentDate);

  const getCurrentTime = () => {
    const date = new Date();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    return `${hours}:${minutes}:${seconds}`;
  };

  const checkEdit = (path) => {
    // e.preventDefault(); // Prevent redirection
    setErrorMessage(
      "Are you sure you want to leave this page without saving your changes?"
    );
    setErrorbox(true);
    seteventTrim(() => async () => {
      localStorage.setItem("isLinearEdit", JSON.stringify(false));
      navigate("/monitor");
    });
  };

  const errorboxclose = () => {
    setErrorbox(false);
  };

  const monitorNavigate = () => {
    if (localStorage.getItem("isLinearEdit") === "true") {
      checkEdit("/monitor");
    } else {
      navigate("/monitor");
    }
  };

  const gridmonitorNavigate = () => {
    if (localStorage.getItem("isLinearEdit") === "true") {
      checkEdit("/gridMonitor");
    } else {
      navigate("/gridMonitor");
    }
  };

  const goBack = () => {
    // navigate go back history
    navigate(-1);
  };

  useEffect(() => {
    const newdate = new Date(startDate);
    seFormattedDateString(moment(newdate).format("dddd, Do MMMM’YY"));
  }, [startDate]);

  useEffect(() => {
    if (isMonitor) {
      document.getElementsByTagName("body")[0].classList.add("dark-theme");
    } else {
      document.getElementsByTagName("body")[0].classList.remove("dark-theme");
    }
    monitorDate();
  }, [location]);
  appTheme === "dark" || isMonitor || adminMode
    ? document.getElementsByTagName("body")[0].classList.add("dark-theme")
    : document.getElementsByTagName("body")[0].classList.remove("dark-theme");
  useEffect(() => {
    if (appTheme === "dark" || adminMode) {
      document.getElementsByTagName("body")[0].classList.add("dark-theme");
    } else {
      document.getElementsByTagName("body")[0].classList.remove("dark-theme");
    }
  }, [appTheme]);

  const handleSearchInput = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    // Clear the existing timeout to prevent multiple searches
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Only trigger search if the query has at least 3 characters
    if (query.length >= 3) {
      const timeout = setTimeout(() => {
        console.log("Searching for:", query);
        // Replace the console.log with your search logic
        // Example: dispatch(SearchChannelAction(query));
      }, 500); // Adjust delay as needed (500ms in this example)
      setTypingTimeout(timeout);
    }
  };

  useEffect(() => {
    const storedTheme = localStorage.getItem("theme") || "dark";
    if (storedTheme === "dark") {
      document.getElementsByTagName("body")[0].classList.add("dark-theme");
    } else {
      document.getElementsByTagName("body")[0].classList.remove("dark-theme");
    }
    dispatch(appThemeAction(storedTheme));
  }, []);

  return (
    <>
      {isMonitor ? (
        <div className={`dashboard-header monito dark`}>
          <Helmet
            bodyAttributes={{
              style: `background-color : ${
                appTheme == "dark" || adminMode ? "#000" : "#fff"
              }`,
            }}
          />
          <div className="left-side">
            <div className="logo">
              <img
                src={playstationLogo}
                alt="logo"
                className="playstationLogo"
              />
              {/* <a href="#">
                    <img src={logoInvert} alt="" />
                </a> */}
              {/* <div className="logo" style={{backgroundImage: `url(${appTheme == "dark" ?  storeFrontAccess?.darkThemeLogoImagePath? image_url+storeFrontAccess?.darkThemeLogoImagePath : logoInvert : storeFrontAccess?.logoImagePath? image_url+storeFrontAccess?.logoImagePath : logo})`, width: '135px', height: '30px'}}></div> */}
            </div>
            <div className="welcome-name">
              <h5>
                {" "}
                {url.includes("gridMonitor")
                  ? "Monitoring Dashboard"
                  : "Playout Monitoring"}{" "}
              </h5>
              <div className="date">
                <img src={clockIcon} alt="Clock" />
                <span>{getCurrentTime()}</span>
              </div>
            </div>
          </div>
          <div className="right-side">
            <div style={{ paddingRight: 20 }}>
              <div
                className="search-box"
                style={{ width: "260px", height: 45 }}
              >
                <input
                  className="border-0 p-2 pr-2"
                  type="text"
                  placeholder="Search for channels and more"
                  value={searchQuery}
                  onChange={handleSearchInput}
                  style={{
                    flex: 1,
                  }}
                />
                <img
                  src={icroundsearch}
                  alt="Search"
                  style={{
                    height: "27px",
                    width: "27px",
                    cursor: "pointer",
                    filter:
                      "brightness(0) saturate(100%) invert(21%) sepia(90%) saturate(5497%) hue-rotate(0deg) brightness(95%) contrast(108%)",
                  }}
                />
              </div>
            </div>

            <div className="dashboard-switch-button">
              <button className="btn btn-primary" onClick={goBack}>
                CMS Dashboard
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className={`dashboard-header ${adminMode ? "dark" : appTheme}`}>
          <Helmet
            bodyAttributes={{
              style: `background-color : ${
                adminMode || appTheme == "dark" ? "#000" : "#fff"
              }`,
            }}
          />
          <div className="left-side">
            {/* <div className="logo" style={{backgroundImage: `url(${image_url}${storeFrontAccess?.logoImagePath})`, width: '135px', height: '30px'}}> */}
            {/* <div className="logo" style={{backgroundImage: `url(${appTheme == "dark" ?  storeFrontAccess?.darkThemeLogoImagePath? image_url+storeFrontAccess?.darkThemeLogoImagePath : logoInvert : storeFrontAccess?.logoImagePath? image_url+storeFrontAccess?.logoImagePath : logo})`, width: '135px', height: '30px'}}> */}

            {/* <a href="#">
                    <img src={logo} alt="" />
                </a> */}
            {/* </div> */}
            <div className="logo">
              <img
                src={playstationLogo}
                alt="logo"
                className="playstationLogo"
              />
              {/* <a href="#">
                    <img src={logoInvert} alt="" />
                </a> */}
              {/* <div className="logo" style={{backgroundImage: `url(${appTheme == "dark" ?  storeFrontAccess?.darkThemeLogoImagePath? image_url+storeFrontAccess?.darkThemeLogoImagePath : logoInvert : storeFrontAccess?.logoImagePath? image_url+storeFrontAccess?.logoImagePath : logo})`, width: '135px', height: '30px'}}></div> */}
            </div>
            <div className="welcome-name">
              <h5>
                Welcome back, {`${userInfo?.firstName} ${userInfo?.lastName}`}
              </h5>
              {/* <h5>Welcome back, {Profile_data?.firstName} {Profile_data?.lastName}</h5> */}
              <div className="date">
                <span>{formattedDate}</span>
              </div>
            </div>
          </div>
          <div className="right-side">
            
            <div className="dashboard-switch-button">
              <span
                class="d-inline-block"
                tabindex="0"
              >
                <Tooltip text="Playout Monitoring" placement="bottom">
                  <button className="monitorBtn p-0" onClick={monitorNavigate}>
                    <img src={playoutMonitoring} alt="" />
                  </button>
                </Tooltip>
              </span>
            </div>

            <div
              className="dashboard-switch-button"
              style={{ marginLeft: 24, paddingRight: 40 }}
            >
              <span
                class="d-inline-block"
                tabindex="0"
              >
                <Tooltip text="Dashboard Monitoring" placement="bottom">
                  <button className="monitorBtn p-0" onClick={gridmonitorNavigate}>
                    <img src={DashboardMonitoring} alt="" />
                  </button>
                </Tooltip>
              </span>
            </div>

            
            <LogoutDropdown Initial={userInfo?.firstName?.charAt(0)} />
          </div>
        </div>
      )}
      {errorbox && (
        <ErrorPopup
          btntext={"Yes"}
          message={errorMessage}
          closebox={() => errorboxclose()}
          overrides={() => eventTrim()}
        />
      )}
    </>
  );
}
